import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import InputTextElement from '../../../../Components/UiComponents/InputTextElement'
import DataTable from '../../../../Components/UiComponents/DataTable';
import { Tooltip } from 'primereact/tooltip';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useForm, Controller } from 'react-hook-form';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { generateCPlan } from '../../../../Services/clientService';
import { get as getClients } from '../../../../Services/clientService';

export default function RelationshipManager(props) {
	const { register, handleSubmit, formState: { errors }, reset, setValue, getValues, trigger, watch, control } = useForm();

	const [loading, setLoading] = useState(false);
	const [newModule, setNewModule] = useState({});
	const [checked, setChecked] = useState(false);
	const [checkedData, setCheckedData] = useState({});

	const toastRef = useRef();
	const navigate = useNavigate();

	useEffect(() => {
		if (props.fieldsData.pipelinePlanSections) {
			let obj1 = _.find(props?.fieldsData?.pipelinePlanSections, { section_name: "Client Business Environment" })?.display_name;
			let obj2 = _.find(props?.fieldsData?.pipelinePlanSections, { section_name: "Future Strategic Initiatives" })?.display_name;
			let combined = { obj1, obj2 };
			setNewModule(combined)
		}
	}, [props.fieldsData.pipelinePlanSections])

	const needsHeader = () => {
		return _.find(props.fieldsData.clientPlanTable, { table_name: "Client Needs" })?.display_name
	}

	const columns = [
		{ field: "needs", header: needsHeader, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const objectivesHeader = () => {
		return _.find(props.fieldsData.clientPlanTable, { table_name: "Client Objectives" })?.display_name
	}

	const columns1 = [
		{ field: "objectives", header: objectivesHeader, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const issuesHeader = () => {
		return _.find(props.fieldsData.clientPlanTable, { table_name: "Client Key Issues" })?.display_name
	}

	const columns2 = [
		{ field: "issues", header: issuesHeader, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const referenceHeader = () => {
		return _.find(props.fieldsData.oppClientPlanDocHeaders, { header_name: "Name" })?.display_name
	}

	const locationHeader = () => {
		return _.find(props.fieldsData.oppClientPlanDocHeaders, { header_name: "Location Reference" })?.display_name
	}

	const columns3 = [
		{ field: "reference", header: referenceHeader, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "location", header: locationHeader, headerClassName: "header-datatable", className: 'row-datatable' }
	]

	const handleSelectedSubStretigies = (checked, item, section) => {
		if (checked) {
			setChecked(checked)
			var checkedData = {
				name: item.strategic_initiative_name,
				strategy: section,
				initiative_description: item.initiative_description
			}
			setCheckedData(checkedData)
		} else {
			setChecked(checked)
		}
	};

	// const generateCPlans = async () => {
	// 	try {
	// 		const clientRes = await getClients(props.opportunityData.client_id, props.customerId, props.branchData)
	// 		if (clientRes.data.client.length > 0) {
	// 			const response = generateCPlan(props.opportunityData.client_id, props.customerId, token);
	// 		} else {
	// 			toastRef.current.showToast({
	// 				type: 'error',
	// 				message: "Client Data is empty"
	// 			});
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }

	const generateCPlans = async () => {
		setLoading(true);
		try {
		  const clientRes = await getClients(props.opportunityData.client_id, props.customerId, props.branchData);
		  
		  // Check if client data is not empty
		  if (clientRes && clientRes.data && clientRes.data.client && clientRes.data.client.length > 0) {
			// Call generateCPlan function and await the response
			const response = await generateCPlan(props.opportunityData.client_id, props.customerId);
			
			if (response && response.data) {
			  // Handle successful response if needed
			  toastRef.current.showToast({
				type: 'success',
				message: 'C-Plan generated successfully!'
			  });
			} else {
			  toastRef.current.showToast({
				type: 'error',
				message: 'Failed to generate C-Plan. Please try again.'
			  });
			}
		  } else {
			toastRef.current.showToast({
			  type: 'error',
			  message: "Client Data is empty"
			});
		  }
		} catch (error) {
		  // Handle any errors that occurred during the API calls
		  toastRef.current.showToast({
			type: 'error',
			message: 'An error occurred while generating C-Plan. Please try again or contact Admin.'
		  });
		} finally {
		  setLoading(false); 
		}
	  };
	  

	const editDirect = () => {
		if (props.opportunityData.client_id && props.opportunityData.client_name) {
			navigate(`/stakeholder/${props.opportunityData.client_id}/${props.shortName}/${props.currVersion}`, { state: { clientName: props.opportunityData.client_name } });
		}
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			{
				<form>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field'>
													{
														_.find(props.fieldsData.clientFieldsNew, { field_name: "Client Name" })?.field_status &&
														<div className="form-group row align-items-center mb-0 mt-0">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{_.find(props.fieldsData.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
															</div>
															<div className="col-md-1 pl-0">
															</div>
															<div className='col pr-0'>
																<label className="form-label-text text-left pointer" onClick={editDirect}>{props.opportunityData.client_name}</label>
															</div>
														</div>
													}
													{
														_.find(props.fieldsData.clientPlanFieldsNew, { field_name: "Brief Summary of Clients High Level Strategy" })?.field_status &&
														<div className="form-group row align-items-center mb-0 mt-0">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{_.find(props.fieldsData.clientPlanFieldsNew, { field_name: "Brief Summary of Clients High Level Strategy" })?.display_name}:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipDataOthers?.Stakeholder_plan?.overall_client_strategy?.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipDataOthers?.Stakeholder_plan?.overall_client_strategy?.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col pr-0'>
																<label className="form-label text-left">{props.clientData.clientPlan.overal_client_strategy}</label>
															</div>
														</div>
													}
													<div className="d-flex mt-10">
														<div className='col-md-6 pl-0'>
															{
																_.find(props.fieldsData.clientPlanTable, { table_name: "Client Needs" })?.status &&
																<div className="box-border-plan">
																	<DataTable
																		value={props.clientData.clientPlan.client_needs}
																		columns={columns}
																		dataKey="_id"
																		isNewField={true}
																	/>
																</div>
															}
														</div>
														<div className='col-md-6 pl-0'>
															{
																_.find(props.fieldsData.clientPlanTable, { table_name: "Client Objectives" })?.status &&
																<div className="box-border-plan">
																	<DataTable
																		value={props.clientData.clientPlan.client_objectives}
																		columns={columns1}
																		dataKey="_id"
																		isNewField={true}
																	/>
																</div>
															}
														</div>
													</div>
													<div className="d-flex mt-20">
														<div className='col-md-6 pl-0'>
															{
																_.find(props.fieldsData.clientPlanTable, { table_name: "Client Key Issues" })?.status &&
																<div className="box-border-plan">
																	<DataTable
																		value={props.clientData.clientPlan.client_key_issues}
																		columns={columns2}
																		dataKey="_id"
																		isNewField={true}
																	/>
																</div>
															}
														</div>
													</div>
												</div>
											}
											{
												key == 'obj2' &&
												<div className="new-field">
													{
														_.find(props.fieldsData.clientPlanFieldsNew, { field_name: "Our Response Target Strategies & Tactics" })?.field_status &&
														<div className="form-group row align-items-center mb-0 mt-0">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{_.find(props.fieldsData.clientPlanFieldsNew, { field_name: "Our Response Target Strategies & Tactics" })?.display_name}:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipDataOthers?.Stakeholder_plan?.target_strategies_tactics?.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipDataOthers?.Stakeholder_plan?.target_strategies_tactics?.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col pr-0'>
																<Controller
																	name="selectedInitiatives"
																	control={control}
																	defaultValue={props.clientData.initiativeSelected}
																	style={{ innerHeight: 10 }}
																	render={({ field }) => {
																		return (
																			<InputTextElement
																				placeholder="Text"
																				name="selectedInitiatives"
																				className="w-full"
																				value={props.clientData.initiativeSelected}
																				disabled
																				{...field}
																			/>
																		);
																	}}
																/>
															</div>
														</div>
													}
													{
														_.find(props.fieldsData.oppClientPlanTable, { table_name: "Initiatives" })?.status &&
														<div className="form-group row align-items-center mb-0 mt-0">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left font-bold">{_.find(props.fieldsData.oppClientPlanTable, { table_name: "Initiatives" })?.display_name}:</label>
															</div>
															<div className="group-table-data pl-0">
																<table className="group-datatable">
																	<thead className="group-table-header">
																		<tr>
																			<th className="checkbox-header"></th>
																			<th className="w-40">{_.find(props.fieldsData.oppClientPlanInitHeaders, { header_name: 'Strategic Initiative' })?.display_name}</th>
																			<th className="w-20">{_.find(props.fieldsData.oppClientPlanInitHeaders, { header_name: 'Person Responsible' })?.display_name}</th>
																			<th className="w-20">{_.find(props.fieldsData.oppClientPlanInitHeaders, { header_name: 'Target Date' })?.display_name}</th>
																		</tr>
																	</thead>
																	<tbody className="group-table-row stakeplan">
																		{
																			props.clientData.clientPlanSectionNew?.map((section, ind) => {
																				return (
																					<React.Fragment>
																						<tr>
																							<td className="group-header"></td>
																							<td className="w-40 group-header" colSpan={3}>
																								<label>{section.strategies}</label>
																							</td>
																						</tr>
																						{section.strategic_initiative?.map((item, index) => (
																							<tr>
																								<td>
																									<CheckboxElement
																										id={`known-${index}`}
																										name={`known-${index}`}
																										value={false}
																										checked={false}
																										onChangeCheck={(e) => { handleSelectedSubStretigies(e.target.checked, item, section) }}
																										className="mr-2"
																									/>
																								</td>
																								<td className="w-40">
																									<label>{item.strategic_initiative_name}</label>
																								</td>
																								<td className="w-20">
																									<label>{item.responsible_user != 'undefined undefined' ? item.responsible_user : ''}</label>
																								</td>
																								<td className="w-20">
																									<label>{item.target_date}</label>
																								</td>
																							</tr>
																						))}
																					</React.Fragment>
																				);
																			})
																		}
																	</tbody>
																</table>
															</div>
														</div>
													}
													{
														checked &&
														<div className="form-group row align-items-center mb-0 mt-0">
															<div className='col pr-0 pl-0'>
																<label className="form-label text-left font-bold">{checkedData.strategy.strategies + ': '}</label> &nbsp;
																<label className="form-label text-left">{checkedData.name}</label>
																<TextareaElement
																	name="myTextarea"
																	defaultValue={checkedData.initiative_description}
																	rows={4}
																	cols={30}
																	placeholder="Enter text here..."
																	className="w-full"
																	disabled={true}
																/>
															</div>
														</div>
													}
													{
														_.find(props.fieldsData.oppClientPlanTable, { table_name: "Document Reference" })?.status &&
														<div className="box-border-plan">
															<label className="form-label text-left font-bold">{_.find(props.fieldsData.oppClientPlanTable, { table_name: "Document Reference" })?.display_name}:</label>
															<DataTable
																value={props.clientData.clientPlan.document_reference}
																columns={columns3}
																dataKey="_id"
																isNewField={true}
															/>
														</div>
													}
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						)
						)
					}
				</form>
			}
			<div className="cancel-footer mt-20">
				<div className='d-flex align-center justify-end pb-0'>
					<ButtonElement className="save-button" type="submit" label="Generate Relationship Manager Report" onClick={generateCPlans} />
				</div>
			</div>
		</div>
	)
}